import {
  ExistingPortItem,
  LagPortInfo,
  PortSpeed,
} from '@/pages/ServiceWizard/ServiceWizard.types'
import { toPortSpeed } from '@/pages/ServiceWizard/portSpeedOptions'

const findPortSpeed = (
  portSpeedOptions: readonly PortSpeed[],
  portType: string | undefined,
  portSpeedMbps: number | undefined
): PortSpeed =>
  portSpeedOptions.find((option) => option.name === portType) ??
  toPortSpeed(portType ?? '', portSpeedMbps ?? 0)

export function processExistingPorts(
  customerExistingPorts: any[],
  portSpeedOptions: readonly PortSpeed[]
): ExistingPortItem[] {
  if (!customerExistingPorts) return []

  // @ts-ignore
  return customerExistingPorts
    .filter(
      ({ component_type, port_type, port_speed_mbps, response_type }) =>
        (component_type !== 'Reuse' &&
          (!!port_type || !!port_speed_mbps) &&
          response_type === 'Port') ||
        response_type === 'LAG'
    )
    .map((port) => {
      const {
        id,
        name,
        location: locationName,
        response_type: responseType,
      } = port

      let portType = port.port_type
      let serviceSid = port.service_sid
      let virtualNetworkName = port.virtual_network_name

      let portSpeed = findPortSpeed(
        portSpeedOptions,
        portType,
        port.port_speed_mbps
      )
      const isLag = responseType === 'LAG'
      let lagCount = 0

      let lagPorts: LagPortInfo[] | undefined

      if (isLag && (port.ports?.length ?? 0) > 0) {
        portType = port.ports![0].port_type
        serviceSid = port.ports![0].service_sid
        virtualNetworkName = port.ports![0].virtual_network_name

        lagCount = port.ports?.length || 1
        portSpeed = {
          ...findPortSpeed(
            portSpeedOptions,
            portType,
            port.ports![0].port_speed_mbps
          ),
        }

        lagPorts = port.ports!.map((p: any) => ({
          id: p.id,
          name: p.name,
          sco: p.sco,
          portType: p.port_type,
          serviceSid: p.service_sid,
        }))
      }

      return {
        portSpeed,
        id,
        sco: port.sco,
        name,
        locationName,
        portType,
        isLag,
        lagCount,
        serviceSid,
        virtualNetworkName,
        services: port.services || [],
        lagPorts,
      }
    })
}
